import { NgModule } from '@angular/core';
import { async } from '@angular/core/testing';
import { RouterModule, Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: ':language',
    loadChildren: async () => (await import('./main/main-page.module')).MainPageModule,
  },
  {
    path: ':language/blog',
    loadChildren: async () => (await import('./blog/blog.module')).BlogModule,
  },
  {
    path: ':language/policy',
    loadChildren: async () => (await import('./private-policy/private-policy.module')).PrivatePolicyModule,
  },
  {
    path: ':language/blog/:name',
    loadChildren: async () => (await import('./blog/blog-detail/blog-details.module')).BlogDetailsModule,
  },
  {
    path: ':language/contact',
    loadChildren: async () => (await import('./contact/contact.module')).ContactModule,
  },
  {
    path: ':language/calculator',
    loadChildren: async () => (await import('./services/calculator/calculator.module')).CalculatorModule,
  },
  {
    path: ':language/maintenance',
    loadChildren: async () => (await import('./services/management/maintenancesupport.module')).MaintenanceSupportModule,
  },
  {
    path: ':language/datascience',
    loadChildren: async () => (await import('./services/datascience/datascience.module')).DatascienceModule,
  },
  {
    path: ':language/visualization',
    loadChildren: async () => (await import('./services/visualization/visualization.module')).VisualizationModule,
  },
  {
    path: ':language/development',
    loadChildren: async () => (await import('./services/development/development.module')).DevelopmentModule,
  },
  {
    path: ':language/optimization',
    loadChildren: async () => (await import('./services/business/business.module')).BusinessModule,
  },
  {
    path: ':language/enterprise',
    loadChildren: async () => (await import('./services/enterprise/enterprise.module')).EnterpriseModule,
  },
  {
    path: ':language/about',
    loadChildren: async () => (await import('./aboutus/aboutus.module')).AboutUsModule,
  },
  // {
  //   path: 'faq',
  //   loadChildren: async () => (await import('./faq/faq.module')).FaqModule,
  // },
  {
    path: ':language/comingsoon',
    loadChildren: async () => (await import('./coming-soon/coming-soon.module')).ComingSoonModule
  },
  {
    path: ':language/404',
    loadChildren: async () => (await import('./page-not-found/page-not-found.module')).PageNotFoundModule,
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // preloadingStrategy: PreloadAllModules,
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    initialNavigation: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
